export default __webpack_public_path__ + "static/media/yeti_icon.min.ed688647.svg";